<template>
  <div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="Chức vụ" prop="title">
        <a-select
          placeholder="- Chọn chức vụ -"
          style="width: 100%;"
          v-model="form.title"
        >
          <a-select-option value="DRAFTERS">
            Người soạn thảo
          </a-select-option>
          <a-select-option value="DRAFTMANAGER">
            Trưởng phòng văn thư
          </a-select-option>
          <a-select-option value="BOD">
            Ban giám đốc
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item has-feedback label="Người dùng" prop="usersIds">
        <SelectUser
          v-model="form.usersIds"
          :initialDatas="form.users ? form.users : []"
          :selectProps="{
            mode: 'multiple',
            placeholder: '- Chọn người dùng -',
            value: form.usersIds,
          }"
        />
      </a-form-model-item>
    </a-form-model>

    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <div style="text-align: right;">
        <a-popconfirm
          title="Xác nhận muốn xóa cấu hình ?."
          ok-text="Có"
          cancel-text="Không"
          @confirm="deleteDocumentConfig"
        >
          <a-button
            type="danger"
            icon="delete"
            style="margin-right: 5px; float: left;"
            :loading="loadingButton"
          >
            Xóa
          </a-button>
        </a-popconfirm>

        <a-button style="margin-right: 5px;" @click="closeDrawerUpdate">
          Đóng
        </a-button>
        <a-button
          type="primary"
          @click="updateDocumentConfig"
          :loading="loadingButton"
        >
          Cập nhật
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import SelectUser from "@/components/common/user/select";
import postQuery from "../data/postData";
export default {
  components: {
    SelectUser,
  },
  props: {
    detailDocumentConfig: {
      type: Object,
      default() {
        return {};
      },
    },
    updateDocumentConfigOnView: {
      type: Function,
      default: null,
    },
    deleteDocumentConfigOnView: {
      type: Function,
      default: null,
    },
    closeDrawerUpdate: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      form: {
        title: undefined,
        usersIds: undefined,
      },
      loadingButton: false,
      rules: {
        usersIds: [
          {
            required: true,
            message: "Người dùng không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    // Xóa cấu hình văn bản.
    deleteDocumentConfig() {
      this.loadingButton = true;
      this.$apollo
        .mutate({
          mutation: postQuery.queryDeleteDocumentConfig,
          variables: {
            id: this.form.id,
          },
        })
        .then(({ data }) => {
          if (data?.deleteDocumentConfig) {
            this.$notification.success({
              message: "Thông báo",
              description: "Xóa cấu hình thành công",
            });
            this.deleteDocumentConfigOnView(data.deleteDocumentConfig);
            this.closeDrawerUpdate();
          }
          this.loadingButton = false;
        })
        .catch((error) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Xóa cấu hình không thành công" + error,
          });
          this.loadingButton = false;
        });
    },
    // Chỉnh sửa cấu hình văn bản
    updateDocumentConfig() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          this.$apollo
            .mutate({
              mutation: postQuery.queryUpdateDocumentConfig,
              variables: {
                id: this.form.id,
                title: this.form.title || null,
                usersIds: this.form.usersIds,
              },
            })
            .then(({ data }) => {
              if (data?.updateDocumentConfig) {
                this.$notification.success({
                  message: "Thông báo",
                  description: "Cập nhật cấu hình thành công",
                });
                this.updateDocumentConfigOnView(data.updateDocumentConfig);
                this.closeDrawerUpdate();
              }
              this.loadingButton = false;
            })
            .catch(() => {
              this.loadingButton = false;
              this.$notification.error({
                message: "Thông báo",
                description: "Chức vụ đã được chọn",
              });
            });
        }
      });
    },
  },
  created() {
    this.form = { ...this.detailDocumentConfig };
    if (this.form.users?.length === 0) {
      this.$set(this.form, "usersIds", []);
    } else {
      const listUser = this.form.users?.map((item) => item.id);
      this.$set(this.form, "usersIds", listUser);
    }
  },
};
</script>
<style></style>
